
export enum SeatType {
  STANDARD = 'standard',
  AISLE = 'aisle',
  STAGE = 'stage',
  EMPTY = 'empty',
  UNAVAILABLE = 'unavailable'
}

export interface Seat {
  id: string; // "r1-c3"
  row: number;
  col: number;
  type: SeatType;
  label?: string; // For manual text on aisles or special seats
  attendeeName?: string;
  attendeeRemark?: string; // To handle duplicates
  isManual?: boolean; // If true, skipped by auto-sorter
}

export interface Attendee {
  id: string;
  name: string;
  remark?: string; // "Dept A", "Dept B" etc.
  status: 'pending' | 'seated' | 'on_leave';
  originalIndex?: number;
}

export interface ConferenceConfig {
  rows: number;
  cols: number;
  title: string;
  useSpacing?: boolean; // Toggle for "Spacing Seat" logic
  spacingRowCount?: number; // 前几排保持间隔就坐，从下一排起不间隔（0 = 全部不间隔）
}

export interface SearchResult {
  seat: Seat;
  matchType: 'exact' | 'fuzzy';
}

// Helper interface for display logic
export interface LogicalCoords {
  rowLabel: number;
  colLabel: number;
  isValid: boolean; // True if this seat is part of the numbering sequence
}

export interface SystemState {
  seats: Seat[];
  config: ConferenceConfig;
  isLocked: boolean;
  hasTotp: boolean;
  serverTime: number;
  dbType?: string;
  version: number; // For optimistic locking
}
